import { FC } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import { LibxFeaturedEntryPage } from './LibxFeaturedEntryPage';
import { PageNotFound } from '../../shop/PageNotFound';
import { LibxGenresContainer } from './genres/LibxGenresContainer';
import LibxProductDetailPage from './productdetail/LibxProductDetailPage';
import { LocalRegionsPage } from './localregions/LocalRegionsPage';
import { NewlyAddedPage } from './NewlyAddedPage';
import { AllTitlesPage } from './AllTitlesPage';

type Props = RouteComponentProps;

const LibxRouteSwitch: FC<Props> = ({ match }) => (
    <Switch>
        <Redirect from={match.path} to={`${match.url}/featured`} exact={true} />
        <Route exact path={`${match.path}/products/:productId`} component={LibxProductDetailPage} />
        <Route exact path={`${match.path}/featured`} component={LibxFeaturedEntryPage} />
        <Route exact path={`${match.path}/newlyadded`} component={NewlyAddedPage} />
        <Route exact path={`${match.path}/products`} component={AllTitlesPage} />
        <Route path={`${match.path}/genres/:genre?/:subGenre?`} component={LibxGenresContainer} />
        <Route path={`${match.path}/localregions/:level1?/:level2?`} component={LocalRegionsPage} />
        <Route component={PageNotFound} />
    </Switch>
);

export default LibxRouteSwitch;
